import SingleSelectPanel from 'components/SingleSelectPanel';

import useBoundaryPanelItems from 'hooks/useBoundaryPanelItems';
import useBoundarySections from 'hooks/useBoundarySections';

import useTranslation from './hooks/useTranslation';

import { ENTITY_TYPE, TEST_ID } from './constants';
import type { BoundaryFieldSchema, FunctionComponent, Props } from './types';

const PrimaryBoundarySelectPanelField: FunctionComponent<Props> = ({
    className = '',
    onChange,
    onClose,
    siteId,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { getSectionKey, sections } = useBoundarySections({ siteId });
    const { handleAsyncFilter, hasNextPage, isLoading, items, noItemsText, onNextPage } =
        useBoundaryPanelItems({ siteId });

    const handleSelected = (boundary: BoundaryFieldSchema) => {
        onChange(boundary);
        onClose?.(boundary);
    };

    return (
        <SingleSelectPanel
            className={className}
            entityType={ENTITY_TYPE}
            getSectionKey={getSectionKey}
            hasNextPage={hasNextPage}
            isLoading={isLoading}
            itemSelected={value}
            items={items}
            label={SEARCH}
            noItemsFoundText={noItemsText}
            onFilter={handleAsyncFilter}
            onNextPage={onNextPage}
            onSelected={handleSelected}
            sections={sections}
            testId={testId}
        />
    );
};

export default PrimaryBoundarySelectPanelField;
